// extracted by mini-css-extract-plugin
export default {"component":"BonusIcon__component--slots-aJv4t","pictogram":"BonusIcon__pictogram--slots-t0RLm"};